import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function WhoIsFor() {
  const isFor = ['Dueños de gatos que viven en monoambientes o departamentos chicos.', 'Inquilinos que no pueden agujerear todas las paredes pero necesitan soluciones ya.', 'Gente que trabaja afuera muchas horas y deja al gato solo.', 'Personas que aman a su mascota pero están hartas de ver su casa destruida.'];
  const isNotFor = ['Gente que tiene casas con jardín o campo donde el gato sale libremente.', 'Personas que prefieren gastar $100.000 en muebles de diseño antes que armar algo casero.', "Dueños que buscan una 'solución mágica' sin dedicarle 5 minutos de juego al día."];
  return <section className="py-12 md:py-20 px-4 bg-white" data-id="element-180">
      <div className="max-w-5xl mx-auto" data-id="element-181">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12" data-id="element-182">
          {/* Who is it for */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-sage/10 p-8 md:p-10 rounded-3xl border border-sage/20" data-id="element-183">
            <h3 className="text-2xl md:text-3xl mb-8 text-sage font-heading" data-id="element-184">
              Esta guía ES para vos si...
            </h3>
            <ul className="space-y-6" data-id="element-185">
              {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-186">
                  <div className="bg-sage text-white rounded-full p-1 mt-1 shrink-0" data-id="element-187">
                    <Check size={16} strokeWidth={3} data-id="element-188" />
                  </div>
                  <p className="text-lg text-warmBrown/90" data-id="element-189">{item}</p>
                </li>)}
            </ul>
          </motion.div>

          {/* Who is it NOT for */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-red-50 p-8 md:p-10 rounded-3xl border border-red-100" data-id="element-190">
            <h3 className="text-2xl md:text-3xl mb-8 text-red-400 font-heading" data-id="element-191">
              Esta guía NO es para vos si...
            </h3>
            <ul className="space-y-6" data-id="element-192">
              {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-193">
                  <div className="bg-red-400 text-white rounded-full p-1 mt-1 shrink-0" data-id="element-194">
                    <X size={16} strokeWidth={3} data-id="element-195" />
                  </div>
                  <p className="text-lg text-warmBrown/90" data-id="element-196">{item}</p>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}